import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TabsState {
  private tabs:
    | {
        id: string;
        status: string;
      }[]
    | undefined;
  private tabsSharedSettings: Record<string, { authorizedUsers: string[]; isRestricted: boolean }> =
    {};

  setTabs(tabs: { id: string; status: string }[]) {
    this.tabs = tabs;
  }

  getTabs(): { id: string; status: string }[] | undefined {
    return this.tabs;
  }

  setTabSharedSettings(
    tabId: string,
    settings: { authorizedUsers: string[]; isRestricted: boolean },
  ) {
    this.tabsSharedSettings[tabId] = settings;
  }

  getTabSharedSettings(tabId: string) {
    return this.tabsSharedSettings[tabId];
  }

  clearTabs() {
    this.tabs = undefined;
  }
}
